





























import { defineComponent, onMounted, ref } from "@vue/composition-api";
import Navigation from "./components/Navigation.vue";
import router from "@/router/index";
import { getDiseasePestTree, PestItemType, SubItem } from "@/api/diseasePest";
import { goBack } from "@/utils/goBack";

export type Item = {
  value: number;
  name: string;
};
export default defineComponent({
  components: {
    Navigation,
  },
  setup() {
    const dataList = ref<Item[]>([]);
    const searchText = ref("");
    searchText.value = router.currentRoute.query.title as string;
    const onSearchModel = ref(false);

    const cropList = ref<PestItemType[]>([]);

    const searchData = async (text: string) => {
      if (text == undefined || text == "") {
        return;
      }

      if (cropList.value.length == 0) {
        const [err, data] = await getDiseasePestTree();
        if (!err && data != undefined && data != null) {
          cropList.value = data.filter((i) => i.id != 0);
        }
      }
      if (cropList.value.length > 0) {
        const tempArr = ref<SubItem[]>([]);
        cropList.value.forEach((item) => {
          item.subsets.forEach((i) => {
            if (i.cropName.includes(searchText.value)) {
              tempArr.value.push(i);
            }
          });
        });
        dataList.value = [];
        dataList.value = tempArr.value.map((f) => {
          return {
            value: f.id,
            name: f.cropName,
          };
        });
        onSearchModel.value = true;
      }
    };

    onMounted(() => {
      //搜索
      searchData(searchText.value);
    });

    const handleSearch = (text: string) => {
      searchText.value = text;
      searchData(text);
    };
    const handleClear = () => {
      searchText.value = "";
      onSearchModel.value = false;
      dataList.value = [];
    };
    return {
      handleBack: () => {
        goBack();
      },
      pageTitle: "",
      handleSearch,
      onSearchModel,
      handleClear,
      searchText,
      dataList,
      handleToDetail: (cid: number, name: string) => {
        router.push({
          path: "/pest/pestSubClass",
          query: {
            cid: (cid as unknown) as string,
            title: name,
            no_back_app: "1",
          },
        });
      },
    };
  },
});
